import * as PIXI from "pixi.js"

export default class PathProxy {

    constructor(d, width, height, resolution) {
        this.nodeName = "path";
        this.d = d;
        this.resolution = resolution;
        this.canvas = document.createElement("canvas");
        this.canvas.width = width;
        this.canvas.height = height;
        this.context = this.canvas.getContext("2d");
        this.context.fillStyle = "#fff";
        this.texture = PIXI.Texture.from(this.canvas);
    }

    getAttribute(attr) {
        return this[attr];
    }

    getAttributeNS(ns, attr) {
        return this[attr];
    }

    setAttribute(attr, value) {
        this[attr] = value;
    }

    setAttributeNS(ns, attr, value) {
        this[attr] = value;
    }

    update() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.fill(new Path2D(this.d));
        this.texture.update();
    }
}
